import React from "react";
import { Skillset } from "./skillset";
import { Roleinfo } from "./roleinfo";
import { Prolearn } from "./prolearn";
import Tab from "../components/tab/tab";

export const Myrole = (propsData) => {
  const roleinfodata = {"desc":propsData?.datas?.jobDescription,"resp":propsData?.datas?.keyResponsibilities};
  const skillData = propsData?.datas?.skillSet?.split(",")+"@@@"+propsData?.datas?.proficiencyName?.split(",");
  const learnData = propsData?.datas?.learning;

  const innertabData = {
    title: ["Role Information", "Skill Set", "Proposed Learning"],
    icon: ["", "", ""],
    status: [, true, true],
    content: [
      <Roleinfo details={roleinfodata} from={propsData?.from} />,
      <Skillset details={skillData}  from={propsData?.from}/>,
      <Prolearn details={learnData}  from={propsData.from}/>,
    ],
    parentClassName: "my-role",
    menuClassName: "tab-role",
    contentParentClassName: "my-role-content",
    contentClassName: ["role-info", "skillset", "pro-learn"],
  };
  return <Tab data={innertabData} />;
};
